"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("../utils");
var _ViewportProvider = require("../ViewportProvider");
var _ThemeProvider = require("../ThemeProvider");
var _PressableListItemBase = _interopRequireDefault(require("../List/PressableListItemBase"));
var _ButtonBase = _interopRequireDefault(require("../Button/ButtonBase"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Public component exported as QuickLinks.Item, for use as children of QuickLinks.
 *
 * Receives props injected by QuickLinks and renders the appropriate child component.
 */const QuickLinksItem = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    tokens,
    variant,
    children,
    ...rest
  } = _ref;
  const viewport = (0, _ViewportProvider.useViewport)();
  const {
    list
  } = (0, _ThemeProvider.useThemeTokens)('QuickLinks', tokens, variant, {
    viewport
  });
  const themeName = list ? 'QuickLinksList' : 'QuickLinksButton';
  const getTokens = (0, _ThemeProvider.useThemeTokensCallback)(themeName, tokens, variant);
  return list ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_PressableListItemBase.default, {
    ref: ref,
    tokens: getTokens,
    ...rest,
    children: children
  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_ButtonBase.default, {
    ref: ref,
    tokens: getTokens,
    ...rest,
    children: children
  });
});
QuickLinksItem.displayName = 'QuickLinksItem';
QuickLinksItem.propTypes = {
  ..._utils.withLinkRouter.propTypes,
  ..._PressableListItemBase.default.propTypes,
  ..._ButtonBase.default.propTypes,
  tokens: (0, _utils.getTokensPropType)('QuickLinksList', 'QuickLinksButton'),
  variant: _utils.variantProp.propType,
  children: _propTypes.default.node
};
var _default = exports.default = (0, _utils.withLinkRouter)(QuickLinksItem);